export const colors = {
  LandingPage_Background: '#FFFFFF',
  LandingPage_Description: '#373737',
  Button_Primary: '#46F34D',
  Button_Secondary: '#D1A219', 
  Header_Background: "#FFFFFF",
  Header_Content: '#000000',
  Black: '#000000',
  Header: '#383C3D',
  Header_Text: "#000000",
  Header_Text_back: "#435152",
  Table_Header: '#BFCACD',
  Action_Button_Back: '#0A6AAD',
  ALERT_BUTTON_GOTO_COLOR: "#c6e2f6",
  ALERT_BUTTON_CLOSE_COLOR:  "#ea969d",
  HEADER: '#2a383b',
  BORDER_BACKGROUND: "#d6d6d6",
  CAR_BOX_EVEN:'#DEDFD5',
  CAR_BOX_ODD:'#f5bf19',
  CARD_LABEL:"#4C5152",
  CARD_DETAIL:"#F5F5F5",
  STATUS_COMPLETE:"#2CDE3A",
  STATUS_CANCELED:"#DF2E38",
  STATUS_PENDING:"##FFCD4B",
  ROW_SELECTED:"#EEE",
  TABLE_BORDER:"rgba(224, 224, 224, 1)",
  SUB_2:"#019b9d",
  WALLET_CARD:"#CC3372",
  WALLET_CARD_SHADOW:"#9E9E9E",
  FACEBOOK_COLOR:"#3b5998",
  BLUE:"#00acee",
  

TAXIPRIMARY: "#06113C",
TAXISECONDORY: "#DDDEEE",

DELIVERYPRIMARY: "#FE805D",
DELIVERYSECONDORY: "#E7F1F9",

BIDTAXIPRIMARY: "#00564c",
BIDTAXISECONDORY: "#eee7ca",

TRANSPARENT: "transparent",
WHITE: "#ffffff",
BLACK: "#000000",
RED: "#FF1E00",
GREEN: "#0CAB03",
YELLOW: "#FFDE59 ",
VIOLET:"#A755C2",
FOOTERTOP: "#cccccc",

primary: {
  main: "#ffc107", // Sarı
  light: "#fff350",
  dark: "#c79100",
  contrastText: "#000"
},
secondary: {
  main: "#FFFFFF",
  contrastText: "#000"
},
third: {
  main: "#000000",
  contrastText: "#FFFFFF"
},
error: {
  main: "#EA4435"
},
textColors: {
  main: "#000",
  light: "#717171"
},
action: {
  active: "#02181D",
  hover: "rgba(144, 202, 249, 0.08)",
  hoverOpacity: 0.08,
  selected: "rgba(144, 202, 249, 0.16)",
  selectedOpacity: 0.16,
  disabled: "rgba(107, 120, 124, 0.3)",
  disabledBackground: "rgba(107, 120, 124, 0.12)",
  disabledOpacity: 0.38,
  focus: "rgba(144, 202, 249, 0.12)",
  focusOpacity: 0.12,
  activatedOpacity: 0.12
}
};

// Modern color palette for the application (Yellow Theme)
export const modernColors = {
primary: "#FFC107", // Ana sarı renk
primaryLight: "#FFF350", // Açık sarı
primaryDark: "#C79100", // Koyu sarı
secondary: "#333333", // Koyu gri
success: "#4CAF50", // Yeşil
warning: "#FF9800", // Turuncu
error: "#F44336", // Kırmızı
info: "#2196F3", // Mavi
background: "#F5F5F5", // Açık gri arkaplan
card: "#FFFFFF", // Kart arkaplanı
drawer: "#FFFFFF", // Drawer arkaplanı
appBar: "#FFFFFF", // AppBar arkaplanı
textPrimary: "#212121", // Ana metin rengi
textSecondary: "#757575", // İkincil metin rengi
border: "#E0E0E0", // Kenarlık rengi
divider: "#EEEEEE", // Ayraç rengi
icon: "#757575", // İkon rengi
shadow: "rgba(0, 0, 0, 0.1)", // Gölge rengi
hover: "#FFF8E1", // Hover rengi (açık sarı)
buttonHover: "#FFB300", // Buton hover rengi (koyu sarı)
gradientStart: "#FFC107", // Gradyan başlangıç rengi
gradientEnd: "#FFD54F", // Gradyan bitiş rengi
};